import { UploadTask } from "../../domain/uploadtask/uploadtask";
import { UploadTaskActionTypes } from "../action-types";
import { UploadTaskActions } from "../actions";
import produce from 'immer';


interface UploadTaskState {
    loading: boolean | null;
    uploadtasks: UploadTask[] | null,
    error: string | null,
    entityLoading: boolean,
    entityError: string | null,
}

const initialState: UploadTaskState = {
    loading: null,
    uploadtasks: null,
    error: null,
    entityLoading: false,
    entityError: null,
}



const reducer = produce((state: UploadTaskState = initialState, action: UploadTaskActions) => {
    switch (action.type) {
        case UploadTaskActionTypes.UPLOADTASK_REQUEST_SEND:
            state.loading = true;
            return state;
        case UploadTaskActionTypes.UPLOADTASK_SUCCESS:
            state.loading = false;
            state.uploadtasks = action.payload;
            return state;
        case UploadTaskActionTypes.UPLOADTASK_ERROR:
            state.loading = false;
            state.error = action.payload;
            return state;
        case UploadTaskActionTypes.UPLOADTASK_CREATE_REQUEST:
            state.entityLoading = true
            state.entityError = ""
            return state;
        case UploadTaskActionTypes.UPLOADTASK_CREATE_SUCCESS:
            state.entityLoading = false
            state.uploadtasks!.push(action.payload)
            state.entityError = ""
            return state;
        case UploadTaskActionTypes.UPLOADTASK_CREATE_ERROR:
            state.entityLoading = false
            state.entityError = action.payload;
            return state;
        case UploadTaskActionTypes.UPLOADTASK_DELETE_SUCCESS:
            state.uploadtasks = state.uploadtasks!.filter((uploadtasks) => uploadtasks.Id() !== action.payload)
            return state;
        default:
            return state;
    }
})

export default reducer;
